(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/lobby/assets/javascripts/lobby-fallback.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/lobby/assets/javascripts/lobby-fallback.js');
"use strict";


const {
  ReactPaper: Paper
} = svs.ui;
const {
  SkeletonLine
} = svs.components.lbUi;
const LobbyFallback = () => React.createElement(React.Fragment, null, React.createElement(SkeletonLine, {
  className: "tabs-loader-title"
}), React.createElement(Paper, {
  branding: "sport",
  className: "tabs-loader-paper"
}, React.createElement(SkeletonLine, {
  className: "tabs-loader-paper-content"
}), React.createElement(SkeletonLine, {
  className: "tabs-loader-paper-content"
}), React.createElement(SkeletonLine, {
  className: "tabs-loader-paper-content"
}), React.createElement(SkeletonLine, {
  className: "tabs-loader-paper-content"
})));
setGlobal('svs.components.marketplaceCompetition.lobby.LobbyFallback', LobbyFallback);

 })(window);